// `video.merge`: videos, or cuts of them, joined in order, live's `VIDEO_MERGE` (spec
// G14-templates, "The steps"), the worker's own ffmpeg. Live lists no such job; a template's run
// starts it.
import { VideoMergeQuote, VideoMergeRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";

export const jobType: JobTypeModule<"video.merge"> = {
  type: "video.merge",
  label: "Merge",
  source: "form",
  pair: "video.merge",
  fields: () => ({}),
  request: VideoMergeRequest,
  quote: VideoMergeQuote,
};
